import React, {useCallback, useEffect, useState} from 'react';
import commonStyle from "../../config/Common.module.scss";
import StyledTable from "../table/StyledTable";
import {OrganizationDataFetcher} from "../../datafetcher/OrganizationDataFetcher";
import InputDialog from "../dialog/InputDialog";
import HttpClient from "../../datafetcher/HttpClient";
import {useParams} from "react-router-dom";
import {useHistory} from "react-router";
import {InputModel, InputOption} from "../../model/InputModel";
import {nanoid} from "nanoid";
import {useOrganization} from "../../hook/useOrganization";
// import {lsi} from "../../datafetcher/LSIDataFetcher";
import PageSummary from "../pagesummary/PageSummary";
import ReverseSolidLinkSmallButton from '../button/ReverseSolidLinkSmallButton';
import {InputModelsToJson} from "../../util/InputModelToJson";
import {ProxyOrgCmd} from "../../model/proxy/cloudlsi-app";
import {AxiosResponse} from "axios";
import _ from "lodash";
import {TextField } from '@mui/material';
import styles from './Organizations.module.scss';
import OutlinedIcon from "../icon/OutlinedIcon";

const deployments:InputOption[] = [
    {label: "Developer" , value: "dev"},
    {label: "Staging" , value: "staging"},
    {label: "Production" , value: "prod"}
]

const deployMethods:InputOption[] = [
    {label: "NEXT.js" , value: "nextjs", icon: "data:image/svg+xml;base64,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"},
    {label: "Web Components" , value: "webc", icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYxIiBoZWlnaHQ9IjEzMiIgdmlld0JveD0iMCAwIDE2MSAxMzIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PGxpbmVhckdyYWRpZW50IHgxPSIwJSIgeTE9IjUwJSIgeTI9IjUwJSIgaWQ9ImEiPjxzdG9wIHN0b3AtY29sb3I9IiMyQTNCOEYiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjMjlBQkUyIiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCB4MT0iMCUiIHkxPSI1MCUiIHkyPSI1MCUiIGlkPSJiIj48c3RvcCBzdG9wLWNvbG9yPSIjMkEzQjhGIiBvZmZzZXQ9IjAlIi8+PHN0b3Agc3RvcC1jb2xvcj0iIzI5QUJFMiIgb2Zmc2V0PSIxMDAlIi8+PC9saW5lYXJHcmFkaWVudD48bGluZWFyR3JhZGllbnQgeDE9IjEwMCUiIHkxPSI1MCUiIHgyPSIwJSIgeTI9IjUwJSIgaWQ9ImMiPjxzdG9wIHN0b3AtY29sb3I9IiNCNEQ0NEUiIG9mZnNldD0iMCUiLz48c3RvcCBzdG9wLWNvbG9yPSIjRTdGNzE2IiBvZmZzZXQ9IjEwMCUiLz48L2xpbmVhckdyYWRpZW50PjxsaW5lYXJHcmFkaWVudCB4MT0iMTAwJSIgeTE9IjUwJSIgeDI9IjAlIiB5Mj0iNTAlIiBpZD0iZCI+PHN0b3Agc3RvcC1jb2xvcj0iI0I0RDQ0RSIgb2Zmc2V0PSIwJSIvPjxzdG9wIHN0b3AtY29sb3I9IiNFN0Y3MTYiIG9mZnNldD0iMTAwJSIvPjwvbGluZWFyR3JhZGllbnQ+PC9kZWZzPjxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+PHBhdGggZmlsbD0iIzE2NkRBNSIgZD0iTTE2MC42IDY1LjlsLTE3LjQgMjkuMy0yNC40LTI5LjcgMjQuNC0yOC45eiIvPjxwYXRoIGZpbGw9IiM4RkRCNjkiIGQ9Ik0xNDEuMyAxMDAuMmwtMjYuNS0zMS43LTE1LjkgMjYuNiAyNC43IDM2LjF6Ii8+PHBhdGggZmlsbD0iIzE2NkRBNSIgZD0iTTE0MSAzMS40bC0yNi4yIDMxLjgtMTUuOS0yNi42TDEyMy42Ljl6Ii8+PHBhdGggZmlsbD0idXJsKCNhKSIgb3BhY2l0eT0iLjk1IiBkPSJNNjEuMSAzMS40SDE0MUwxMjMuNC45SDc4Ljd6Ii8+PHBhdGggZmlsbD0idXJsKCNiKSIgb3BhY2l0eT0iLjk1IiBkPSJNMTE0LjggNjMuM0gxNTlsLTE1LjktMjYuOEg5OC44Ii8+PHBhdGggZmlsbD0idXJsKCNjKSIgb3BhY2l0eT0iLjk1IiBkPSJNMTQxLjMgMTAwLjNINjFsMTcuNiAzMC41aDQ1eiIvPjxwYXRoIGZpbGw9IiMwMTAxMDEiIGQ9Ik03OC42IDEzMC44TDQxIDY1LjggNzkuMS44SDM3LjlMLjQgNjUuOGwzNy41IDY1eiIvPjxwYXRoIGZpbGw9InVybCgjZCkiIG9wYWNpdHk9Ii45NSIgZD0iTTExNC44IDY4LjRIMTU5bC0xNS45IDI2LjhIOTguOCIvPjwvZz48L3N2Zz4="}
]

export default function Organizations() {

    const handleBuild = (id: string) => {
        HttpClient.get("/api/jcr/org/" + id + "/build").then((response) => {
            console.log(response);
        });
    }
    const history = useHistory();
    const query = new URLSearchParams(history.location.search);
    const params: any = useParams();
    const [newOpen, setNewOpen] = useState(false);
    const [updateData, setUpdateData] = useState<ProxyOrgCmd | null>(null);
    const [updateOrg, setUpdateOrg] = useState("");
    const [formKey , setFormKey] = useState("");
    const [dataFetcher] = useState(new OrganizationDataFetcher(handleBuild));
    const [deleteList,setDeleteList] = useState<string[]>([]);
    // const [searchProfiles,setSearchProfiles] = useState<InputOption[]>();
    //const [memberCores,setMemberCores] = useState<InputOption[]>();
    //const [connectorTypes,setConnectorTypes] = useState<InputOption[]>();
    //const [connectorNames,setConnectorNames] = useState<InputOption[]>();
    //const [memberCore,setMemberCore] = useState<string>();
    //const [lsiURL, setLsiURL] = useState<string>();
    const orgCmdProp = useOrganization();
    const [search, setSearch] = useState<string>();



    const handleCloseNewDialog = () => {
        setNewOpen(false);
    }

    // const handleOpenNewDialog = () => {
    //     setNewOpen(true);
    // }

    const resetScreen = useCallback(() => {
                history.push({
                    pathname: '/organizations',
                    search: history.location.search
                });
                setUpdateData(null);
                setUpdateOrg("");
                setFormKey(nanoid());
            }
    ,[history])

    const handleCloseUpdateDialog = () => {
        resetScreen();
    }

    const handleUpdateDialog = (values: InputModel[]) => {
        // let data: any = {};
        // values.forEach(object => {
        //     data[object.id] = object.defaultValue;
        // })
        // data['createdAt'] = updateData.createdAt;
        // data['modifiedAt'] = new Date().getTime();
        let data = InputModelsToJson(values)
        data = _.merge(_.cloneDeep(updateData), data);

        HttpClient.post("/api/proxy/orgs/" + updateData?.orgCode, data).then((response) => {
            dataFetcher.load().then((xxxx) => {
               resetScreen();
            });

            // when update selected organization. refresh whole data again.
            if(response.data.response.orgCode === orgCmdProp?.currentOrg?.orgCode) {
                orgCmdProp?.updateCurrentOrg();
            }

        }).catch((e) => {
            console.log(e);
        })
    }

    const handleSaveDialog = (values: InputModel[]) => {
        // let data: any = {};
        // values.forEach(object => {
        //     data[object.id] = object.defaultValue;
        // })
        let data = InputModelsToJson(values)
        data = _.merge(_.cloneDeep(updateData), data);

        HttpClient.post("/api/proxy/orgs", data).then((response) => {
            setUpdateOrg("");
            setUpdateData(null);
            setFormKey(nanoid());
            if(orgCmdProp) orgCmdProp.refresh();
            // let responseCmd = response.data as ResponseCmd<any>;
            // dataFetcher.load().then(() => {
            //     setNumberOfRecords(dataFetcher.getTotalRecords);
            // });
        }).catch((e) => {
        })

        setNewOpen(false);
    }

    const handleDelete = () => {
        if(window.confirm("Are you sure to remove?")) {
            HttpClient.delete("/api/jcr/org/" + deleteList.join(",")).then((response) => {
                resetScreen();
                setDeleteList([]);
                if(orgCmdProp) orgCmdProp.refresh();
            }).catch((e) => {
                setDeleteList([]);
            })
        }
    }


    if (params.oname && updateOrg !== params.oname) {
        setTimeout(() => {
            setUpdateOrg(params.oname);
        }, 100);
    }

    // function initWithError(newUpdateData: ProxyOrgCmd) {
    //     // let newSearchProfileOptions: InputOption[] = [];
    //     // newSearchProfileOptions.push({value: "", label: "None"});
    //     // setMemberCores(newSearchProfileOptions);
    //     // setSearchProfiles(newSearchProfileOptions);
    //     setUpdateData(newUpdateData);
    // }

    function initOrganization(response: AxiosResponse<ProxyOrgCmd>) {
        let newUpdateData = response.data;
        setUpdateData(newUpdateData);
        // let lsiUrl = newUpdateData.lsiConfig.searchURL;
        // let memberCore = newUpdateData.lsiConfig.memberCore;
        // if (lsiUrl && memberCore) {

            // if(memberCore && memberCore !== "") { // already have member core
            //
            //     let allPromies: Promise<any>[] = [];
            //     allPromies.push(lsi.schema.membercores(updateOrg))
            //     Promise.all(allPromies).then((results) => {
            //
            //         // update search profile
            //         let memberCoreData: MemberCoreCmd[] = results[0].data;
            //
            //         let newMemberCoreOptions: InputOption[] = [];
            //         newMemberCoreOptions.push({value: "", label: "None"});
            //         memberCoreData.forEach((object: any) => {
            //             newMemberCoreOptions.push({value: object.externalId, label: object.name});
            //         })
            //         setMemberCores(newMemberCoreOptions);
            //
            //         // update search profile
            //         let data: LiteSearchProfileCmd[] = results[1].data;
            //         let newSearchProfileOptions: InputOption[] = [];
            //         newSearchProfileOptions.push({value: "", label: "None"});
            //         data.forEach((object: any) => {
            //             newSearchProfileOptions.push({value: object.name, label: object.name});
            //         })
            //         setSearchProfiles(newSearchProfileOptions);
            //
            //         setUpdateData(newUpdateData);
            //
            //     }).catch((error) => {
            //         initWithError(newUpdateData);
            //     })
            // } else { // did not have member core
            //     lsi.schema.membercores(updateOrg).then((response) => {
            //         let memberCoreData = response.data;
            //
            //         let newMemberCoreOptions: InputOption[] = [];
            //         newMemberCoreOptions.push({value: "", label: "None"});
            //         memberCoreData.forEach((object: any) => {
            //             newMemberCoreOptions.push({value: object.externalId, label: object.name});
            //         })
            //         setMemberCores(newMemberCoreOptions);
            //         if(memberCoreData.length > 0) {
            //             newUpdateData.lsiConfig.memberCore = memberCoreData[0].externalId;
            //             lsi.search.searchProfiles(lsiUrl, memberCore).then(response => {
            //                 let data: LiteSearchProfileCmd[] = response.data;
            //                 let newSearchProfileOptions: InputOption[] = [];
            //                 newSearchProfileOptions.push({value: "", label: "None"});
            //                 data.forEach((object: any) => {
            //                     newSearchProfileOptions.push({value: object.name, label: object.name});
            //                 })
            //                 setSearchProfiles(newSearchProfileOptions);
            //                 setUpdateData(newUpdateData);
            //             }).catch(error => {
            //                initWithError(newUpdateData);
            //             });
            //         } else {
            //             initWithError(newUpdateData);
            //         }
            //
            //     }).catch(error => {
            //         initWithError(newUpdateData);
            //     })
            // }
        // } else {
        //     setUpdateData(newUpdateData);
        // }
    }


    useEffect(() => {
        if(updateOrg !== "") {
            HttpClient.get("/api/proxy/orgs/" + updateOrg).then((response:AxiosResponse<ProxyOrgCmd>) => {
                if(response.data !== null) {
                    if(response.data.proxyStatus.fromJcr === false) {
                        HttpClient.post("/api/proxy/orgs/" + updateOrg, response.data).then(async (response) => {
                            initOrganization(response)
                        })
                    } else {
                        initOrganization(response);
                    }
                } else {
                    resetScreen();
                }
            }).catch((e) => {
                resetScreen();
            })
        }
    },[updateOrg,resetScreen])

    // useEffect(() => {
    //     if(updateData['memberCore'] && updateData['lsiURL']) {
    //         lsi.search.searchProfiles(updateData['lsiURL'],updateData['memberCore']).then((response) => {
    //             if (response.data) {
    //                 let data: LiteSearchProfileCmd[] = response.data;
    //                 let newSearchProfileOptions: InputOption[] = [];
    //                 newSearchProfileOptions.push({value: "", label: "None"});
    //                 data.forEach((object: any) => {
    //                     newSearchProfileOptions.push({value: object.name, label: object.name});
    //                 })
    //                 setSearchProfiles(newSearchProfileOptions);
    //             }
    //         })
    //     }
    // }, [updateData]);

    const handleSearchString = (event:React.ChangeEvent<HTMLInputElement>) => {
        let value = event.currentTarget.value;
        setSearch(value);
        dataFetcher.search(value.trim());
    }
    const newButton = <><TextField
        type={"text"}
        label="Search Organization"
        autoComplete="off"
        autoCapitalize="off"
        variant="outlined"
        value={search}
        fullWidth={true}
        size={"small"}
        onChange={handleSearchString}
        inputProps={{className: styles.SearchInput}}
        // InputProps={{
        //     startAdornment: <OutlinedIcon className={styles.SearchIcon}>search</OutlinedIcon>,
        // }}
    /></>
    // do not allow to create organization in here
    // <IconLinkButton tooltip={"Add New Organization"}  key="newOrgButton" id="newOrgButton" data-action="createNewOrg"  variant={"contained"} onClick={handleOpenNewDialog}>
    //     <OutlinedIcon className={styles.Icon} >add_circle_outline</OutlinedIcon>
    // </IconLinkButton>;

    const deleteButton = <ReverseSolidLinkSmallButton id="deleteOrgButton" data-action="deleteOrgs" variant={"contained"} onClick={handleDelete}>
        <OutlinedIcon className={styles.Icon} >delete</OutlinedIcon>
        Remove ({deleteList.length})
    </ReverseSolidLinkSmallButton>;

    let showDialog = newOpen || (updateOrg !== "" && updateData != null && updateData.orgCode);
    const booleanOptions: InputOption[] = [
            { label: "true", value: true},
            { label: "false", value: false},
    ]

    const unitDigitTypes: InputOption[] = [
        { label: "2", value: 2},
        { label: "3", value: 3},
        { label: "4", value: 4},
        { label: "5", value: 5},
    ]

    const availabilitySortTypes: InputOption[] = [
        {label: "Total", value: "Total"},
        {label: "Branch", value: "Branch"},
    ]

    const availabilityQtyTypes: InputOption[] = [
        {label: "Total", value: "Total"},
        {label: "Branch", value: "Branch"},
        {label: "Both", value: "Both"},
    ]

    const defaultSortTypes: InputOption[] = [
        {label: "Closest Match", value: "Closest Match"},
        {label: "Description", value: "Description"},
        {label: "Price", value: "Price"},
        {label: "Most Popular", value: "Most Popular"},
        {label: "Availability", value: "Availability"},
    ]

    // if(showDialog) {
    //     console.log(updateData);
    // }
    return <React.Fragment>
        <div className={commonStyle.ContentContainer + " " + commonStyle.ContentContainerOverflowX}>
            <PageSummary type={"organizations"} title={"Organizations Management"} desc={"Manage all organizations"}/>
            {   showDialog && updateData !== null &&
                <InputDialog
                    id={"organization"}
                    title={newOpen ? "New Organization" : "Update Organization"}
                    handleClose={newOpen ? handleCloseNewDialog : handleCloseUpdateDialog}
                    handleSave={newOpen ? handleSaveDialog : handleUpdateDialog}
                    open={true}
                    inserted={newOpen ? true : false}
                    fields={[
                        {id: "orgCode", group:"info" , label: "CloudLSI shortname", defaultValue: newOpen ? "" : updateData.orgCode , required: true , editable: (newOpen ? true : false)},
                        {id: "siteCode", group:"info", label: "Website code", defaultValue: newOpen ? "" : updateData.siteCode , required: false , editable: true},
                        {id: "name", group:"info", label: "Name", defaultValue: newOpen ?"" : updateData.name , required: true , editable: true},
                        {id: "website", group:"info",label: "Domain Name", defaultValue: newOpen ? "" : updateData.website, required: true , editable: true},
                        {id: "cdnURL", group:"info",label: "CDN URL", defaultValue: newOpen ? "" : updateData.cdnURL, required: false , editable: true},

                        {id: "erpConfig.url", group:"sprest",label: "Server URL", defaultValue: newOpen ? "" : updateData.erpConfig.url, required: true , editable: true},
                        {id: "erpConfig.apiKey", group:"sprest",label: "SPRest API Key", defaultValue: newOpen ? "" : updateData.erpConfig.apiKey, required: true , editable: true},
                        {id: "erpConfig.siteUser", group:"sprest", label: "Site User", defaultValue: newOpen ? "" : updateData.erpConfig.siteUser, required: false , editable: true},
                        {id: "erpConfig.sitePassword", group:"sprest",type: "password",  label: "Site Password", defaultValue: newOpen ? "" : updateData.erpConfig.sitePassword, required: false , editable: true},
                        {id: "erpConfig.anonymousUser", group:"sprest",label: "Anonymous User", defaultValue: newOpen ? "" : updateData.erpConfig.anonymousUser, required: false , editable: true},
                        {id: "erpConfig.anonymousPassword", group:"sprest", type: "password", label: "Anonymous Password", defaultValue: newOpen ? "" : updateData.erpConfig.anonymousPassword, required: false , editable: true},

                        {id: "lsiConfig.searchURL", group:"lsi",label: "Lsi URL", defaultValue: newOpen ? "" : updateData.lsiConfig.searchURL, required: true , editable: true},
                        {id: "lsiConfig.apiKey", group:"lsi",label: "Lsi API Key", defaultValue: newOpen ? "" : updateData.lsiConfig.apiKey, required: true , editable: true},
                        {id: "lsiConfig.memberCore", group:"lsi", label: "Member Core", defaultValue: newOpen ? "" : updateData.lsiConfig.memberCore, required: true , editable: true},
                        {id: "lsiConfig.connectorType", group:"lsi", label: "Connector Type", defaultValue: newOpen ? "" : updateData.lsiConfig.connectorType, required: true , editable: true},
                        {id: "lsiConfig.connectorName", group:"lsi",label: "Connector Name", defaultValue: newOpen ? "" : updateData.lsiConfig.connectorName, required: true , editable: true},
                        {id: "lsiConfig.searchProfile", group:"lsi", label: "Search Profile", defaultValue: updateData.lsiConfig.searchProfile, required: false , editable: true},

                        {id: "deployMethod", group:"info",type: "select", label: "Deploy Method", defaultValue:  updateData.deployMethod, required: false , editable: true, options: deployMethods},
                        {id: "deployments", group:"info",type: "multi", label: "Deployments", defaultValue:  updateData.deployments, required: false , editable: true, options: deployments},

                        // {id: "eclipseURL", label: "Eclipse URL", defaultValue: newOpen ? "" : updateData.eclipseURL, required: false , editable: true},

                        {id: "solrURL", group:"info",label: "Solr URL", defaultValue: newOpen ? "" : updateData.solrURL, required: true , editable: true},
                        {id: "jcrURL", group:"info",label: "JCR URL", defaultValue: newOpen ? "" : updateData.jcrURL, required: true , editable: true},


                        {id: "portalURL", group:"portal",label: "Server URL", defaultValue: newOpen ? "" : updateData.portalURL, required: true , editable: true},
                        {id: "portalUser", group:"portal",label: "Site User", defaultValue: newOpen ? "" : updateData.portalUser, required: true , editable: true},
                        {id: "portalPwd", type:"password" , group:"portal",label: "Site Password", defaultValue: newOpen ? "" : updateData.portalPwd, required: true , editable: true},

                        // products
                        {id: "ppaConfig.mainBranchId", group:"ppa",label: "Main Branch ID", defaultValue: newOpen ? "" : updateData.ppaConfig.mainBranchId, required: false , editable: true},
                        {id: "ppaConfig.excludeProductsByStockStatus", group:"ppa",label: "Exclude Status", defaultValue: newOpen ? "" : updateData.ppaConfig.excludeProductsByStockStatus, required: false , editable: true},
                        {id: "ppaConfig.excludeAvailabilityFromBranch", group:"ppa",label: "Exclude Availability", defaultValue: newOpen ? "" : updateData.ppaConfig.excludeAvailabilityFromBranch, required: false , editable: true},
                        {id: "ppaConfig.includeProductsByKeywords", group:"ppa",label: "Include Keywords", defaultValue: newOpen ? "" : updateData.ppaConfig.includeProductsByKeywords, required: false , editable: true},
                        {id: "ppaConfig.excludeProductsByKeywords", group:"ppa",label: "Exclude Keywords", defaultValue: newOpen ? "" : updateData.ppaConfig.excludeProductsByKeywords, required: false , editable: true},
                        {id: "ppaConfig.includeProductsByBranchIds", group:"ppa",label: "Include Branch IDs", defaultValue: newOpen ? "" : updateData.ppaConfig.includeProductsByBranchIds, required: false , editable: true},
                        {id: "ppaConfig.excludeProductsByBranchIds", group:"ppa",label: "Exclude Branch IDs", defaultValue: newOpen ? "" : updateData.ppaConfig.excludeProductsByBranchIds, required: false , editable: true},
                        {id: "ppaConfig.includeProductsByPriceLines", group:"ppa",label: "Include Price Lines", defaultValue: newOpen ? "" : updateData.ppaConfig.includeProductsByPriceLines, required: false , editable: true},
                        {id: "ppaConfig.excludeProductsByPriceLines", group:"ppa",label: "Exclude Price Lines", defaultValue: newOpen ? "" : updateData.ppaConfig.excludeProductsByPriceLines, required: false , editable: true},
                        {id: "ppaConfig.includeProductsByBuyLines", group:"ppa",label: "Include Buy Lines", defaultValue: newOpen ? "" : updateData.ppaConfig.includeProductsByBuyLines, required: false , editable: true},
                        {id: "ppaConfig.excludeProductsByBuyLines", group:"ppa",label: "Hide Buy Lines", defaultValue: newOpen ? "" : updateData.ppaConfig.excludeProductsByBuyLines, required: false , editable: true},
                        {id: "ppaConfig.includeProductByRecorderPriceLines", group:"ppa",label: "Include Reorder Price Lines", defaultValue: newOpen ? "" : updateData.ppaConfig.includeProductByRecorderPriceLines, required: false , editable: true},
                        {id: "ppaConfig.excludeCatalogProducts", type:"select", options: booleanOptions, group:"ppa",label: "Exclude Catalog Products", defaultValue: newOpen ? false : updateData.ppaConfig.excludeCatalogProducts, required: false , editable: true},
                        {id: "ppaConfig.loadExtendData", type:"select", options: booleanOptions, group:"ppa",label: "Load Extended Data (SellPkgQty)", defaultValue: newOpen ? false : updateData.ppaConfig.loadExtendData, required: false , editable: true},
                        {id: "ppaConfig.includePWDData", type:"select", options: booleanOptions, group:"ppa",label: "Include PDW Data/Search", defaultValue: newOpen ? false : updateData.ppaConfig.includePWDData, required: false , editable: true},
                        {id: "ppaConfig.includeCategorySearch", type:"select", options: booleanOptions, group:"ppa",label: "Include Category Search", defaultValue: newOpen ? false : updateData.ppaConfig.includeCategorySearch, required: false , editable: true},
                        {id: "ppaConfig.defaultSortBy", type:"select", options: defaultSortTypes, group:"ppa",label: "Default SortBy", defaultValue: newOpen ? "" : updateData.ppaConfig.defaultSortBy, required: false , editable: true},
                        {id: "ppaConfig.useAlternateProductDescription", type:"select", options: booleanOptions, group:"ppa",label: "Use Alternate Product Description", defaultValue: newOpen ? false : updateData.ppaConfig.useAlternateProductDescription, required: false , editable: true},
                        {id: "ppaConfig.useShipToCustomerPartNumber", type:"select", options: booleanOptions, group:"ppa",label: "Use ShipTo Customer Part Numbers", defaultValue: newOpen ? false : updateData.ppaConfig.useShipToCustomerPartNumber, required: false , editable: true},
                        {id: "ppaConfig.lsiDrillDownDisplay", type:"select", options: booleanOptions, group:"ppa",label: "LSI Drilldown Display", defaultValue: newOpen ? false : updateData.ppaConfig.lsiDrillDownDisplay, required: false , editable: true},
                        {id: "ppaConfig.lsiMultiSelectFacet", type:"select", options: booleanOptions, group:"ppa",label: "LSI Multi-Select Facets", defaultValue: newOpen ? false : updateData.ppaConfig.lsiMultiSelectFacet, required: false , editable: true},
                        {id: "ppaConfig.displayCategoryProductCount", type:"select", options: booleanOptions, group:"ppa",label: "Display Category Product Count", defaultValue: newOpen ? false : updateData.ppaConfig.displayCategoryProductCount, required: false , editable: true},
                        {id: "ppaConfig.displayCategorySEO", type:"select", options: booleanOptions, group:"ppa",label: "Display Category SEO Text", defaultValue: newOpen ? false : updateData.ppaConfig.displayCategorySEO, required: false , editable: true},
                        {id: "ppaConfig.priorityERPPartNumberMatch", type:"select", options: booleanOptions, group:"ppa",label: "Import P/O - Prioritize ERP PartNumber Match", defaultValue: newOpen ? false : updateData.ppaConfig.priorityERPPartNumberMatch, required: false , editable: true},

                        // pricing
                        {id: "ppaConfig.displayListPrice", type:"select", options: booleanOptions, group:"ppa",label: "Display List Price", defaultValue: newOpen ? false : updateData.ppaConfig.displayListPrice, required: false , editable: true},
                        {id: "ppaConfig.unitPriceDisplayDigit", type:"select", options: unitDigitTypes, group:"ppa",label: "Unit Price Display Digits", defaultValue: newOpen ? false : updateData.ppaConfig.unitPriceDisplayDigit, required: false , editable: true},
                        {id: "ppaConfig.requireLoginForPricing", type:"select", options: booleanOptions, group:"ppa",label: "Require Login for PPricing", defaultValue: newOpen ? false : updateData.ppaConfig.requireLoginForPricing, required: false , editable: true},
                        {id: "ppaConfig.priceFromERP", type:"select", options: booleanOptions, group:"ppa",label: "Get Price from ERP", defaultValue: newOpen ? false : updateData.ppaConfig.priceFromERP, required: false , editable: true},
                        {id: "ppaConfig.allowSwitchBranch", type:"select",options: booleanOptions, group:"ppa",label: "Allow User Branch Selection", defaultValue: newOpen ? true : updateData.ppaConfig.allowSwitchBranch, required: false , editable: true},
                        {id: "ppaConfig.enabledMoneySaverAlert", type:"select",options: booleanOptions, group:"ppa",label: "Enable Money Saver Alerts", defaultValue: newOpen ? true : updateData.ppaConfig.enabledMoneySaverAlert, required: false , editable: true},

                        // availability
                        {id: "ppaConfig.availabilitySortType", type:"select", options: availabilitySortTypes, group:"ppa",label: "Availability Sort Type", defaultValue: newOpen ? "Total" : updateData.ppaConfig.availabilitySortType, required: false , editable: true},
                        {id: "ppaConfig.displayProductAvailability", type:"select", options: booleanOptions, group:"ppa",label: "Display Product Availability", defaultValue: newOpen ? true : updateData.ppaConfig.displayProductAvailability, required: false , editable: true},
                        {id: "ppaConfig.requireLoginForAvailability", type:"select",options: booleanOptions, group:"ppa",label: "Require Login For Availability", defaultValue: newOpen ? true : updateData.ppaConfig.requireLoginForAvailability, required: false , editable: true},
                        {id: "ppaConfig.displayAvailableQty", type:"select", options: booleanOptions, group:"ppa",label: "Display Available Qty", defaultValue: newOpen ? true : updateData.ppaConfig.displayAvailableQty, required: false , editable: true},
                        {id: "ppaConfig.availableQtyType", type:"select", options: availabilityQtyTypes, group:"ppa",label: "Available Qty Type", defaultValue: newOpen ? "Total" : updateData.ppaConfig.availableQtyType, required: false , editable: true},
                        {id: "ppaConfig.displayDeliveryBranch", type:"select", options: booleanOptions, group:"ppa",label: "Display Delivery Branch Availability", defaultValue: newOpen ? true : updateData.ppaConfig.displayDeliveryBranch, required: false , editable: true},

                        {id: "ppaConfig.includeBranchAvailability", type:"select",options: booleanOptions, group:"ppa",label: "Include Branch Availability Detail", defaultValue: newOpen ? true : updateData.ppaConfig.includeBranchAvailability, required: false , editable: true},
                        {id: "ppaConfig.displayAvailabilityStockDate", type:"select",options: booleanOptions, group:"ppa",label: "Display Availability Stock Date", defaultValue: newOpen ? true : updateData.ppaConfig.displayAvailabilityStockDate, required: false , editable: true},
                        {id: "ppaConfig.useHomeBranchStockDate", type:"select",options: booleanOptions, group:"ppa",label: "Use Home Branch Stock Date", defaultValue: newOpen ? true : updateData.ppaConfig.useHomeBranchStockDate, required: false , editable: true},
                        {id: "ppaConfig.useBOPlentyDateOnly", type:"select",options: booleanOptions, group:"ppa",label: "Use B/O Plenty Date Only", defaultValue: newOpen ? true : updateData.ppaConfig.useBOPlentyDateOnly, required: false , editable: true},
                        {id: "ppaConfig.displayBODayRange", type:"select",options: booleanOptions, group:"ppa",label: "Display Availability B/O Day Range", defaultValue: newOpen ? true : updateData.ppaConfig.displayBODayRange, required: false , editable: true},
                        {id: "ppaConfig.showProductImageStatusFlag", type:"select",options: booleanOptions, group:"ppa",label: "Show Product Image Status Flags", defaultValue: newOpen ? true : updateData.ppaConfig.showProductImageStatusFlag, required: false , editable: true},

                        {id: "ppaConfig.useCloudLSIForPricingAndAvailabilityForAnonymous", type:"select",options: booleanOptions, group:"ppa",label: "Show Pricing and Availability From Anonymous", defaultValue: newOpen ? true : updateData.ppaConfig.useCloudLSIForPricingAndAvailabilityForAnonymous, required: false , editable: true},

                        {id: "ppaConfig.backOrderText",  group:"ppa",label: "backOrderText", defaultValue: newOpen ? true : updateData.ppaConfig.backOrderText, required: false , editable: true},
                        {id: "ppaConfig.dropShipText", group:"ppa",label: "backOrderText", defaultValue: newOpen ? true : updateData.ppaConfig.dropShipText, required: false , editable: true},

                    ]}
                    groups={[
                        {id: "info", name: "General"},
                        {id: "lsi", name: "LSI Server"},
                        {id: "sprest", name: "SPRest Server"},
                        {id: "portal", name: "Portal Server"},
                        {id: "ppa", name: "Products, Pricing, & Availability"},
                    ]}
                    contentText={null}/>
            }
            <StyledTable key={formKey}
                         handleDeleteLists={(ids) => setDeleteList(ids)}
                         hasCheckBox={false}
                         dataFetcher={dataFetcher}

                         title={"Organizations"}
                         actionComponents={[newButton]}
                         deleteButton={deleteButton}

                         rowsPerPage={20}
                         page={parseInt((query.get("page") === null ? "0" : query.get("page")!))}
                         rowsPerPageOptions={[5,10,20,40,60,{label: "All" , value: -1}]}/>
        </div>
    </React.Fragment>
}
